import {
  CREATE_SIZE_FAILURE,
  CREATE_SIZE_REQUEST,
  GET_ALL_SIZE_REQUEST,
  GET_ALL_SIZE_SUCCESS,
  GET_ALL_SIZE_FAILURE,
  DELETE_SIZE_REQUEST,
  DELETE_SIZE_FAILURE,
  UPDATE_SIZE_REQUEST,
  UPDATE_SIZE_FAILURE,
  DELETE_SIZE_SUCCESS,
} from "./ActionType";

const initialState = {
  sizes: [],
  loading: false,
  error: "",
};

export const sizeReducer = (state = initialState, action) => {
  switch (action.type) {
    case CREATE_SIZE_REQUEST:
      return { ...state, loading: true };

    case CREATE_SIZE_FAILURE:
      return { ...state, loading: false, error: action.payload };

    case GET_ALL_SIZE_REQUEST:
      return { ...state, loading: true };

    case GET_ALL_SIZE_SUCCESS:
      return { ...state, loading: false, error: "", sizes: action.payload };

    case GET_ALL_SIZE_FAILURE:
      return { ...state, loading: false, error: action.payload };

    case DELETE_SIZE_REQUEST:
      return { ...state, loading: true };

    case DELETE_SIZE_SUCCESS:
      return {
        ...state,
        loading: false,
        error: "",
        sizes: state.sizes?.response?.filter(sz => sz.id !== action.payload)  // Remove deleted category
      };

    case DELETE_SIZE_FAILURE:
      return { ...state, loading: false, error: action.payload };

    case UPDATE_SIZE_REQUEST:
      return { ...state, loading: true };

    case UPDATE_SIZE_FAILURE:
      return { ...state, loading: false, error: action.payload };

    default:
      return state;
  }
};
